import React from 'react';

import './not-found-page.scss';

const NotFoundPage = (): JSX.Element => (
  <div className="not-found-page">
    <h1>Not found <span>:(</span></h1>
    <p>Sorry, but the page you were trying to view does not exist.</p>
    <p>It looks like this was the result of a mistyped address.</p>
  </div>
);

export default NotFoundPage;
